/**
 * In-memory registry of Global Search section providers.
 */

import type { GlobalSearchSectionProvider } from './types';

const providers = new Map<string, GlobalSearchSectionProvider>();

export const registerSearchProvider = (
  provider: GlobalSearchSectionProvider,
): void => {
  providers.set(provider.id, provider);
};

/** Clears all providers — for tests only. */
export const clearSearchProviders = (): void => {
  providers.clear();
};

export const getSearchProviders = (): GlobalSearchSectionProvider[] =>
  Array.from(providers.values());

export const getEnabledSearchProviders = (
  hasPermission: (permission: string) => boolean,
): GlobalSearchSectionProvider[] =>
  getSearchProviders().filter((provider) => hasPermission(provider.permission));
